import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Returns URL search params from the current browser location.
 */
export function useQueryParams() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}
